import {
  route as brandPageRoute,
  PathParameters as BrandPathParameters,
} from "@faire/web-api--source/routes/www/brand/brandToken";
import {
  route as productPageRoute,
  PathParameters as ProductPathParameters,
} from "@faire/web-api--source/routes/www/product/productToken";
import { useRouteMatch } from "react-router-dom";

type Token = string;

export const usePathProductToken = (): Token | "" => {
  const productPageMatch =
    useRouteMatch<ProductPathParameters>(productPageRoute);
  return productPageMatch?.params.productToken ?? "";
};

export const usePathBrandToken = (): Token | "" => {
  const brandPageMatch = useRouteMatch<BrandPathParameters>(brandPageRoute);
  return brandPageMatch?.params.brandToken ?? "";
};
